import { render, staticRenderFns } from "./SplitProjectStatusPills.vue?vue&type=template&id=2fbf5942&scoped=true&"
import script from "./SplitProjectStatusPills.vue?vue&type=script&lang=js&"
export * from "./SplitProjectStatusPills.vue?vue&type=script&lang=js&"
import style0 from "./SplitProjectStatusPills.vue?vue&type=style&index=0&id=2fbf5942&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbf5942",
  null
  
)

export default component.exports